console.log('✅ bread-crumb.js loaded successfully!');

/**
 * Builds the Basic Product Card component
 * @param {Object} product - The product data object
 * @returns {string} - The HTML string for the basic product card
 */
export async function buildComponentBreadcrumb(
  text1,
  link1,
  text2,
  link2,
  text3,
  link3,
  text4,
  link4,
  text5,
  link5
) {
  // console.log(`🔄 Building Component: BasicProductCard - Product Name: ${name}`);

  try {
    const parts = [];

    const renderPart = (text, link) => {
      if (!text && !link) return '';
      return link
        ? `<span><a href="${link}">${text}</a></span>`
        : `<span class="currentNodeStyle">${text}</span>`;
    };

    const tryAdd = (text, link, isFirst = false) => {
      if (!text && !link) return;
      if (!isFirst) parts.push(`<span> \\ </span>`);
      parts.push(renderPart(text, link));
    };

    tryAdd(text1, link1, true);
    tryAdd(text2, link2);
    tryAdd(text3, link3);
    tryAdd(text4, link4);
    tryAdd(text5, link5);

    // Build the product card HTML
    const html = `
           <span class="breadcrumbX">${parts.join('')}</span>
        `;

    // console.log("✅ BasicProductCard built successfully.");

    // Register event listeners (if any needed in future)
    //  registerEventListenerToAttach(attachEventListenersBasicProductCard);

    return html;
  } catch (err) {
    console.error('❌ Error building BasicProductCard:', err);
    return '<div>Error loading product card</div>';
  }
}

/**
 * Attaches event listeners to the Basic Product Card component
 */
function attachEventListenersBasicProductCard() {
  try {
    // Attach event listeners if needed in the future
    console.log('✅ BasicProductCard event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to BasicProductCard:', error);
  }
}
